import { useMount, useUnmount } from 'ahooks';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxSpin } from 'components/RevxSpin';
import { MultiTypeEnum, SKU, SKUPart } from 'domains/skuDomain';
import { useEffect } from 'react';
import MultiSKUDetail from './MultiSkuDetail';
import SingleSkuDetail from './SingleSkuDetail';
import SkuCreateWithInheritanceView from './SkuCreateWithInheritanceView';
import { SkuTable } from './SkuTable';
import SkuTesterWizard from './SkuTester/SkuTesterWizard';
import { SkuBleedSize } from './components/SkuBleedSize';

const SkuAdmin = () => {
  const curItem = useAppSelector((state) => state.sku.curItem);
  const topItem = useAppSelector((state) => state.sku.curTopItem);
  const createWithInheritanceVisible = useAppSelector(
    (state) => state.sku.createWithInheritanceVisible
  );
  const skuTesterVisible = useAppSelector(
    (state) => state.sku.skuTesterState.visible
  );
  const saving = useAppSelector((state) => state.loading.effects.sku.saveSku);
  const removing = useAppSelector(
    (state) => state.loading.effects.sku.removeSku
  );
  const dispatch = useAppDispatch();

  useMount(() => {
    dispatch.sku.getSkuTypes();
    dispatch.eqpt.getEqptTypes();
  });
  useUnmount(() => {
    dispatch.sku.reset();
    dispatch.app.setState({
      filterForceHidden: false,
    });
  });

  useEffect(() => {
    if (curItem) {
      dispatch.app.setState({
        filterForceHidden: true,
      });
    } else {
      dispatch.app.setState({
        filterForceHidden: false,
      });
    }
  }, [curItem, dispatch.app]);

  return (
    <>
      <RevxSpin spinning={saving || removing}>
        {!createWithInheritanceVisible && (
          <>
            <SkuBleedSize />
            <SkuTable pagerStateProp="defaultPager" />
          </>
        )}
        {curItem &&
          (topItem ? (
            <SingleSkuDetail
              sku={(curItem as SKUPart).part}
              topSku={topItem}
              skuPart={curItem as SKUPart}
            />
          ) : (curItem as SKU).multiType === MultiTypeEnum.WRAPPER ? (
            <MultiSKUDetail sku={curItem} />
          ) : (
            <SingleSkuDetail sku={curItem} />
          ))}
        {createWithInheritanceVisible && <SkuCreateWithInheritanceView />}
        {skuTesterVisible && <SkuTesterWizard />}
      </RevxSpin>
    </>
  );
};

export default SkuAdmin;
